export default __webpack_public_path__ + "static/media/client5.51eb976a.jpg";